import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTopic from '../../../../components/newsTopic';
import ContentTitle from '../../../../components/contentTitle';
import NewsList from '../../../../components/newsList';

class GuoxueBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { guoxueTopic, guoxueTitle, guoxueList0, jiaoyuList, guoxueList1 },
        } = this.props;

        return (
            <div id="guoxueNewsList" className={styles.guoxue_box}>
                <Chip id="50079" type="struct" title="国学公益栏标题" groupName="国学公益栏" content={guoxueTopic}>
                    <NewsTopic />
                </Chip>
                <Chip
                    id="75104"
                    type="recommend"
                    title="国学公益栏头条"
                    groupName="国学公益栏"
                    content={guoxueTitle}
                    translate="handleNewsContentData">
                    <ContentTitle />
                </Chip>
                <Chip
                    id="75105"
                    type="recommend"
                    title="国学公益栏新闻列表1"
                    groupName="国学公益栏"
                    content={guoxueList0}
                    translate="handleNewsContentData">
                    <NewsList isList />
                </Chip>
                <Chip
                    id="195335"
                    type="recommend"
                    title="教育新闻列表"
                    groupName="国学公益栏"
                    content={jiaoyuList}
                    translate="handleNewsContentData">
                    <NewsList hasTitle isList />
                </Chip>
                <Chip
                    id="75106"
                    type="recommend"
                    title="国学公益栏新闻列表2"
                    groupName="国学公益栏"
                    content={guoxueList1}
                    translate="handleNewsContentData">
                    <NewsList isList />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(GuoxueBox);
